export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите имя ', trigger: 'blur' },
    ],

};
